<div class="modal-header">
    <h4 class="modal-title">{{ wizardTitle }}</h4>
</div>
<form name="form" #form="ngForm">
    @if (step === 0) {
        <div class="modal-body">
            <div class="report-card-list d-flex flex-column gap-2 mb-2">
                <button type="button" class="report-card report-card-primary" (click)="selectReportType(EquipmentReportType.Daily)">
                    <div class="report-card-icon">
                        <fa-icon [icon]="faCircleCheck" size="lg"></fa-icon>
                    </div>
                    <div class="report-card-content">
                        <div class="report-card-title">Daily Report</div>
                        <div class="report-card-subtitle">My equipment is running normally</div>
                    </div>
                </button>
                <button type="button" class="report-card report-card-danger" (click)="selectReportType(EquipmentReportType.Issue)">
                    <div class="report-card-icon">
                        <fa-icon [icon]="faTriangleExclamation" size="lg"></fa-icon>
                    </div>
                    <div class="report-card-content">
                        <div class="report-card-title">Report an Issue</div>
                        <div class="report-card-subtitle">My equipment needs service</div>
                    </div>
                </button>
                <button type="button" class="report-card report-card-warning" (click)="selectReportType(EquipmentReportType.Fuel)">
                    <div class="report-card-icon">
                        <fa-icon [icon]="faGasPump" size="lg"></fa-icon>
                    </div>
                    <div class="report-card-content">
                        <div class="report-card-title">Fuel Need</div>
                        <div class="report-card-subtitle">My equipment is running low on fuel</div>
                    </div>
                </button>
                <button type="button" class="report-card report-card-info" (click)="selectReportType(EquipmentReportType.Grease)">
                    <div class="report-card-icon">
                        <fa-icon [icon]="faOilCan" size="lg"></fa-icon>
                    </div>
                    <div class="report-card-content">
                        <div class="report-card-title">Grease or Fluid Needed</div>
                        <div class="report-card-subtitle">My equipment needs grease or fluid refill</div>
                    </div>
                </button>
                <button type="button" class="report-card report-card-neutral" (click)="selectReportType(EquipmentReportType.Mechanic)">
                    <div class="report-card-icon">
                        <fa-icon [icon]="faWrench" size="lg"></fa-icon>
                    </div>
                    <div class="report-card-content">
                        <div class="report-card-title">Mechanic Inspection</div>
                    </div>
                </button>
                <button type="button" class="report-card report-card-secondary" (click)="selectReportType(EquipmentReportType.Tire)">
                    <div class="report-card-icon">
                        <fa-icon [icon]="faTruck" size="lg"></fa-icon>
                    </div>
                    <div class="report-card-content">
                        <div class="report-card-title">Tire Issue</div>
                        <div class="report-card-subtitle">Flat, punctured, or worn out tire</div>
                    </div>
                </button>
            </div>
        </div>
        <div class="modal-footer">
            <button type="button" class="btn btn-secondary" (click)="cancel()">Cancel</button>
        </div>
    } @else if (isLoadingDetail) {
        <div class="modal-body text-center py-5">
            <fa-icon [icon]="faSpinner" [animation]="'spin'" size="2x"></fa-icon>
            <div class="mt-2">Loading report...</div>
        </div>
        <div class="modal-footer">
            <button type="button" class="btn btn-secondary" (click)="cancel()">Cancel</button>
        </div>
    } @else if (selectedReportType === EquipmentReportType.Daily) {
        <div class="modal-body">
            <app-daily-report-form [dailyReport]="dailyReport" [jobOptions]="jobOptions" [employeeOptions]="employeeOptions" [equipmentOptions]="equipmentOptions"></app-daily-report-form>
        </div>
        <div class="modal-footer">
            <button id="btnSave" type="submit" class="btn btn-primary" (click)="save()" [disabled]="isSaving">
                @if (isSaving) {
                    <span><fa-icon [icon]="faSpinner" [animation]="'spin'"></fa-icon>&nbsp;Saving</span>
                } @else {
                    <span>Save</span>
                }
            </button>
            <button id="btnCancel" type="button" class="btn btn-secondary" (click)="cancel()" [disabled]="isSaving">Cancel</button>
        </div>
    } @else if (selectedReportType === EquipmentReportType.Issue) {
        <div class="modal-body">
            <app-issue-report-form [issueReport]="issueReport" [jobOptions]="jobOptions" [employeeOptions]="employeeOptions" [equipmentOptions]="equipmentOptions" [skillCategoryOptions]="skillCategoryOptions" [mechanicOptions]="mechanicOptions"></app-issue-report-form>
        </div>
        <div class="modal-footer">
            <button id="btnSave" type="submit" class="btn btn-primary" (click)="save()" [disabled]="isSaving">
                @if (isSaving) {
                    <span><fa-icon [icon]="faSpinner" [animation]="'spin'"></fa-icon>&nbsp;Saving</span>
                } @else {
                    <span>Save</span>
                }
            </button>
            <button id="btnCancel" type="button" class="btn btn-secondary" (click)="cancel()" [disabled]="isSaving">Cancel</button>
        </div>
    } @else if (selectedReportType === EquipmentReportType.Fuel) {
        <div class="modal-body">
            <app-fuel-request-form [fuelRequest]="fuelRequest" [jobOptions]="jobOptions" [employeeOptions]="employeeOptions" [equipmentOptions]="equipmentOptions"></app-fuel-request-form>
        </div>
        <div class="modal-footer">
            <button id="btnSave" type="submit" class="btn btn-primary" (click)="save()" [disabled]="isSaving">
                @if (isSaving) {
                    <span><fa-icon [icon]="faSpinner" [animation]="'spin'"></fa-icon>&nbsp;Saving</span>
                } @else {
                    <span>Save</span>
                }
            </button>
            <button id="btnCancel" type="button" class="btn btn-secondary" (click)="cancel()" [disabled]="isSaving">Cancel</button>
        </div>
    } @else if (selectedReportType === EquipmentReportType.Grease) {
        <div class="modal-body">
            <app-grease-fluid-request-form [greaseFluidRequest]="greaseFluidRequest" [jobOptions]="jobOptions" [employeeOptions]="employeeOptions" [equipmentOptions]="equipmentOptions"></app-grease-fluid-request-form>
        </div>
        <div class="modal-footer">
            <button id="btnSave" type="submit" class="btn btn-primary" (click)="save()" [disabled]="isSaving">
                @if (isSaving) {
                    <span><fa-icon [icon]="faSpinner" [animation]="'spin'"></fa-icon>&nbsp;Saving</span>
                } @else {
                    <span>Save</span>
                }
            </button>
            <button id="btnCancel" type="button" class="btn btn-secondary" (click)="cancel()" [disabled]="isSaving">Cancel</button>
        </div>
    } @else if (selectedReportType === EquipmentReportType.Mechanic) {
        <div class="modal-body">
            <app-mechanic-inspection-form [inspection]="mechanicInspection" [employeeOptions]="employeeOptions" [equipmentOptions]="equipmentOptions"></app-mechanic-inspection-form>
        </div>
        <div class="modal-footer">
            <button id="btnSave" type="submit" class="btn btn-primary" (click)="save()" [disabled]="isSaving">
                @if (isSaving) {
                    <span><fa-icon [icon]="faSpinner" [animation]="'spin'"></fa-icon>&nbsp;Saving</span>
                } @else {
                    <span>Save</span>
                }
            </button>
            <button id="btnCancel" type="button" class="btn btn-secondary" (click)="cancel()" [disabled]="isSaving">Cancel</button>
        </div>
    } @else if (selectedReportType === EquipmentReportType.Tire) {
        <div class="modal-body">
            <app-tire-report-form [tireReport]="tireReport" [jobOptions]="jobOptions" [employeeOptions]="employeeOptions" [equipmentOptions]="equipmentOptions"></app-tire-report-form>
        </div>
        <div class="modal-footer">
            <button id="btnSave" type="submit" class="btn btn-primary" (click)="save()" [disabled]="isSaving">
                @if (isSaving) {
                    <span><fa-icon [icon]="faSpinner" [animation]="'spin'"></fa-icon>&nbsp;Saving</span>
                } @else {
                    <span>Save</span>
                }
            </button>
            <button id="btnCancel" type="button" class="btn btn-secondary" (click)="cancel()" [disabled]="isSaving">Cancel</button>
        </div>
    }
</form>
